module.exports = __webpack_public_path__ + "static/media/SeaFarerInternetService5.8ba456b7.png";